import { TracerProvider } from '../entities';
import { ObservabilitySystem } from '../interfaces';

type DelegatingTracerProvider = {
  getDelegate: () => TracerProvider;
};

type FlushableTracerProvider = {
  forceFlush: () => Promise<void>;
};

const isDelegatingTracerProvider = (
  provider: TracerProvider,
): provider is TracerProvider & DelegatingTracerProvider =>
  typeof (provider as Partial<DelegatingTracerProvider>).getDelegate === 'function';

const isFlushableTracerProvider = (
  provider: TracerProvider,
): provider is TracerProvider & FlushableTracerProvider =>
  typeof (provider as Partial<FlushableTracerProvider>).forceFlush === 'function';

export const getFlushableTracerProvider = (
  observabilitySystem: ObservabilitySystem,
): FlushableTracerProvider | null => {
  const globalProvider = observabilitySystem.getTracerProvider();
  const provider = isDelegatingTracerProvider(globalProvider)
    ? globalProvider.getDelegate()
    : globalProvider;

  return isFlushableTracerProvider(provider) ? provider : null;
};
